import {
  IconButton,
  Popover,
  Tooltip,
  useTheme,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { useRef, useState } from 'react';

interface HelpButtonProps {
  children: React.ReactNode;
}

export const HelpButton: React.FC<HelpButtonProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const theme = useTheme();

  return (
    <>
      <Tooltip title="Help" arrow>
        <IconButton
          ref={anchorRef}
          onClick={() => setOpen((prev) => !prev)}
          style={{
            backgroundColor: theme.palette.secondary.main,
            color: '#fff',
            width: 40,
            height: 40,
          }}
          size="small"
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{ style: { background: 'transparent', boxShadow: 'none', paddingBottom: 12 } }}
      >
        {children}
      </Popover>
    </>
  );
};
